import { render } from "./payment.vue?vue&type=template&id=65f8d253&scoped=true"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"

import "./payment.vue?vue&type=style&index=0&id=65f8d253&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hkun\\Downloads\\print_shop-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f8d253"]])

export default __exports__